// Radiation Activity units with conversion factors to becquerel (Bq)
export const radiationActivityUnits = [
  { id: 'becquerel', name: 'Becquerel', symbol: 'Bq', plural: 'Becquerels', factor: 1 },
  { id: 'kilobecquerel', name: 'Kilobecquerel', symbol: 'kBq', plural: 'Kilobecquerels', factor: 1e3 },
  { id: 'megabecquerel', name: 'Megabecquerel', symbol: 'MBq', plural: 'Megabecquerels', factor: 1e6 },
  { id: 'gigabecquerel', name: 'Gigabecquerel', symbol: 'GBq', plural: 'Gigabecquerels', factor: 1e9 },
  { id: 'terabecquerel', name: 'Terabecquerel', symbol: 'TBq', plural: 'Terabecquerels', factor: 1e12 },
  { id: 'curie', name: 'Curie', symbol: 'Ci', plural: 'Curies', factor: 3.7e10 },
  { id: 'millicurie', name: 'Millicurie', symbol: 'mCi', plural: 'Millicuries', factor: 3.7e7 },
  { id: 'microcurie', name: 'Microcurie', symbol: 'µCi', plural: 'Microcuries', factor: 3.7e4 },
  { id: 'nanocurie', name: 'Nanocurie', symbol: 'nCi', plural: 'Nanocuries', factor: 37 },
  { id: 'picocurie', name: 'Picocurie', symbol: 'pCi', plural: 'Picocuries', factor: 0.037 },
  { id: 'rutherford', name: 'Rutherford', symbol: 'Rd', plural: 'Rutherfords', factor: 1e6 },
  { id: 'disintegrations-per-second', name: 'Disintegrations/Second', symbol: 'dps', plural: 'Disintegrations/Second', factor: 1 },
  { id: 'disintegrations-per-minute', name: 'Disintegrations/Minute', symbol: 'dpm', plural: 'Disintegrations/Minute', factor: 1/60 },
];

export const popularRadiationActivityConversions = [
  { from: 'becquerel', to: 'curie' },
  { from: 'curie', to: 'becquerel' },
  { from: 'becquerel', to: 'kilobecquerel' },
  { from: 'megabecquerel', to: 'millicurie' },
  { from: 'gigabecquerel', to: 'curie' },
  { from: 'microcurie', to: 'becquerel' },
];

export const getUnitById = (id) => radiationActivityUnits.find(unit => unit.id === id);

export const convertRadiationActivity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert radioactivity units and learn the conversion formula.`;
};
